import { $Center, $CoverSection, $StoreSearch } from './SearchCover.parts';

export function SearchCover() {
	return (
		<$CoverSection backgroundImageUrl="/assets/images/phone-cover.jpg" withOverlayColor>
			<$Center vertical>
				<$StoreSearch />
			</$Center>
		</$CoverSection>
	);
}
